import classNames from 'classnames';
import React from 'react';

import styles from './list-item.scss';

interface Props {
  className?: string;
  children: any;
  key?: any;
  onClick?: any;
}

const ListItem = ({ children, className, ...props }: Props) => {
  return (
    <div className={classNames(styles.listItem, className)} {...props}>
      {children}
    </div>
  );
};

export default ListItem;
